module.exports = __webpack_public_path__ + "img/pic-1.135f9d70.png";